import React, { memo, useMemo } from 'react';

import { Avatar, Box, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { MAX_AMOUNT_AVATARS } from './TeamChatReadBy.constants';
import { avatarStackStyles, avatarStyles, rootStyles } from './TeamChatReadBy.styles';
import { getInitial, getReaders } from './TeamChatReadBy.utils';

const TeamChatReadBy = memo(({ lastOwnMessageAt, readReceipts, members, currentChatUserId }) => {
  const readers = useMemo(
    () => getReaders({ lastOwnMessageAt, members, readReceipts, currentChatUserId }),
    [lastOwnMessageAt, readReceipts, members, currentChatUserId],
  );

  if (!readers.length) {
    return null;
  }

  const visible = readers.slice(0, MAX_AMOUNT_AVATARS);
  const overflow = readers.length - visible.length;
  const tooltip = readers.map(reader => reader.nickname).join(', ');

  return (
    <Box sx={rootStyles}>
      <Typography variant="regular12">Read by</Typography>
      <Tooltip title={tooltip}>
        <Box sx={avatarStackStyles}>
          {visible.map(reader => (
            <Avatar key={reader.chatUserId} sx={avatarStyles}>
              {getInitial(reader.nickname)}
            </Avatar>
          ))}
          {overflow > 0 && <Avatar sx={avatarStyles}>{`+${overflow}`}</Avatar>}
        </Box>
      </Tooltip>
    </Box>
  );
});
TeamChatReadBy.propTypes = {
  members: PropTypes.arrayOf(PropTypes.object).isRequired,
  readReceipts: PropTypes.object.isRequired,
  currentChatUserId: PropTypes.string,
  lastOwnMessageAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TeamChatReadBy;
